import { parse, stringify } from '@/helpers/qs'
import { decode, encode } from '@/helpers/param-encoder'
import type {
    NonSkuLabGrownDiamondsFilters,
    NonSkuLabGrownDiamondSortInput,
} from '@/graphql/api'

export function decodeNonSkuLabGrownDiamondFiltersAndSort(
    fragment: string | undefined
): DecodedLabGrownDiamondFiltersAndIdentifier | undefined {
    if (!fragment) {
        return undefined
    }

    const parsed = parse(fragment)

    return {
        filters:
            typeof parsed['filters'] === 'string'
                ? decode(parsed['filters'])
                : undefined,
        sort:
            typeof parsed['sort'] === 'string'
                ? decode(parsed['sort'])
                : undefined,
        stoneId:
            typeof parsed['stoneId'] === 'string'
                ? parsed['stoneId']
                : undefined,
    }
}

export function encodeNonSkuLabGrownDiamondParams(
    filters: NonSkuLabGrownDiamondsFilters | undefined,
    sort: NonSkuLabGrownDiamondSortInput | undefined,
    stoneId: string | undefined = undefined
): string | undefined {
    const fragment = {
        filters: encode(filters),
        sort: encode(sort),
        stoneId: stoneId,
    }

    return Object.values(fragment).filter((v) => !!v).length
        ? `#${stringify(fragment)}`
        : undefined
}

export type DecodedLabGrownDiamondFiltersAndIdentifier = {
    filters: NonSkuLabGrownDiamondsFilters | undefined
    sort: NonSkuLabGrownDiamondSortInput | undefined
    stoneId: string | undefined
}
